import api from "./axios";
import { fetchAndDownload } from "../utils/exportCsv";

// Each business is a top-level "client" now — the same endpoint powers
// the Clients list, search, and stats.
export const listAllBusinesses = (params = {}) => api.get("/businesses", { params });
export const businessStats = () => api.get("/businesses/stats");
export const getBusiness = (id) => api.get(`/businesses/${id}`);
export const createBusiness = (payload) => api.post("/businesses", payload);
export const updateBusiness = (id, payload) => api.put(`/businesses/${id}`, payload);
export const deleteBusiness = (id) => api.delete(`/businesses/${id}`);

// Provision a customer login user for this business (formerly /clients/{id}/login).
// payload may carry an optional { username, password } — both auto-generate when omitted.
export const createBusinessLogin = (id, payload = {}) =>
  api.post(`/businesses/${id}/login`, payload);
// Reset the customer login password. Pass { password } to set a specific one,
// or omit it for a fresh one-time temp password.
export const resetBusinessLoginPassword = (id, payload = {}) =>
  api.post(`/businesses/${id}/login/reset-password`, payload);

// Deactivate a client's portal access — deletes the linked customer login
// (users row). The business itself, its drive, fields and tasks survive.
export const removeBusinessLogin = (id) => api.delete(`/businesses/${id}/login`);

// Admin-only activity timeline for a client (spatie/laravel-activitylog).
export const getBusinessActivity = (id, params = {}) =>
  api.get(`/businesses/${id}/activity`, { params });

export const listBusinessFieldGroups = (businessId, params = {}) =>
  api.get(`/businesses/${businessId}/field-groups`, { params });
export const createBusinessFieldGroup = (businessId, payload) =>
  api.post(`/businesses/${businessId}/field-groups`, payload);

// Clones field groups (and their fields) from another business into this one.
// payload: { source_business_id, copy_values?, group_ids?: number[] }
export const importBusinessFieldGroups = (businessId, payload) =>
  api.post(`/businesses/${businessId}/field-groups/import`, payload);

export const listBusinessTasks = (businessId, params = {}) =>
  api.get(`/businesses/${businessId}/tasks`, { params });
export const assignBusinessTask = (businessId, payload) =>
  api.post(`/businesses/${businessId}/tasks`, payload);
export const updateBusinessTaskPriority = (businessId, taskMasterId, priority) =>
  api.patch(`/businesses/${businessId}/tasks/${taskMasterId}`, { priority });
// Broader edit of an attachment — priority and/or the auto-invoice block.
// Send `auto_invoice: false` to switch billing off.
export const updateBusinessTask = (businessId, taskMasterId, payload) =>
  api.patch(`/businesses/${businessId}/tasks/${taskMasterId}`, payload);
export const removeBusinessTask = (businessId, taskMasterId) =>
  api.delete(`/businesses/${businessId}/tasks/${taskMasterId}`);

// Admin-only: stream all clients as CSV — every predefined column plus one
// column per custom field group/field. Honours the list's search/is_active.
export const exportBusinesses = (params = {}) =>
  fetchAndDownload("/businesses/export", params, "clients");

// Admin-only: download the bulk-import xlsx template + run the bulk import.
export const downloadBulkImportTemplate = () =>
  fetchAndDownload("/businesses/sample-template", {}, "ClientBusinesses_Template");
export const bulkImportBusinesses = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/businesses/bulk-import", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
